import { render, staticRenderFns } from "./ParentAppointment.vue?vue&type=template&id=248ee025&"
import script from "./ParentAppointment.vue?vue&type=script&lang=js&"
export * from "./ParentAppointment.vue?vue&type=script&lang=js&"
import style0 from "./ParentAppointment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports